var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Text } from '@fluentui/react';
var TitleBar = function (_a) {
    var title = _a.title, subTitle = _a.subTitle, banner = _a.banner;
    var markup = (_jsxs("div", __assign({ className: " flex justify-between align-middle py-1 pb-2 px-2 bg-[#f0f0f0]" }, { children: [_jsxs("div", { children: [_jsx(Text, __assign({ variant: "xLarge" }, { children: title })), _jsx("br", {}), _jsx(Text, __assign({ variant: "smallPlus" }, { children: subTitle }))] }), _jsx("div", { children: banner })] })));
    return _jsx(_Fragment, { children: markup });
};
export default TitleBar;
